/**
 * Client-side drawing tool constants.
 * Labels, icons, and replay configuration.
 */

import type { LucideIcon } from 'lucide-react';
import type { DrawingTool } from '@vtak/shared';
import {
  Pentagon,
  Square,
  Circle,
  Spline,
  Route,
  ShieldAlert,
  Ruler,
} from 'lucide-react';

/** Human-readable labels for each drawing tool */
export const TOOL_LABELS: ReadonlyMap<DrawingTool, string> = new Map([
  ['polygon', 'Polygon'],
  ['rectangle', 'Rectangle'],
  ['circle', 'Circle'],
  ['freeform', 'Freeform'],
  ['route', 'Route'],
  ['geofence', 'Geofence'],
  ['measurement', 'Measure'],
]);

/** Lucide icons for each drawing tool */
export const TOOL_ICONS: ReadonlyMap<DrawingTool, LucideIcon> = new Map([
  ['polygon', Pentagon],
  ['rectangle', Square],
  ['circle', Circle],
  ['freeform', Spline],
  ['route', Route],
  ['geofence', ShieldAlert],
  ['measurement', Ruler],
]);

/** Number of vertices used to approximate circles in 3D mode */
export const CIRCLE_POLYGON_SEGMENTS = 64;

/** Available replay speed multipliers */
export const REPLAY_SPEEDS = [1, 2, 4, 8, 16] as const;

/** Base tick interval for replay playback (ms) */
export const REPLAY_TICK_MS = 100;
